export var mobileMin = 480;
export var mobileLargeMin = 640;
export var tabletSmallMin = 688;
export var tabletMin = 768;
export var laptopMin = 960;
export var desctopMin = 1280;
export var mediaQueryMobileMin = "(min-width: ".concat(mobileMin, "px)");
export var mediaQueryMobileLargeMin = "(min-width: ".concat(mobileLargeMin, "px)");
export var mediaQueryTabletSmallMin = "(min-width: ".concat(tabletSmallMin, "px)");
export var mediaQueryTabletMin = "(min-width: ".concat(tabletMin, "px)");
export var mediaQueryLaptopMin = "(min-width: ".concat(laptopMin, "px)");
export var mediaQueryDesktopMin = "(min-width: ".concat(desctopMin, "px)");